var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16.5C12.4183 16.5 16 12.9183 16 8.5C16 4.08173 12.4183 0.5 8 0.5C3.58173 0.5 0 4.08173 0 8.5C0 12.9183 3.58173 16.5 8 16.5ZM11.5164 5.6111C11.578 4.91029 10.838 5.19885 10.838 5.19885C10.2915 5.42506 9.72798 5.65493 9.15837 5.88728C7.39213 6.60773 5.56739 7.35205 4.01298 8.08458C3.17013 8.39378 3.6635 8.70296 3.6635 8.70296L4.99973 9.1152C5.61643 9.3007 5.94536 9.09459 5.94536 9.09459L8.82336 7.13642C9.85122 6.4356 9.60454 7.01275 9.35786 7.2601L7.19933 9.32131C6.87042 9.60989 7.03488 9.85725 7.17878 9.98091C7.58661 10.3408 8.58986 10.9991 9.02786 11.2865C9.14182 11.3613 9.21752 11.411 9.2345 11.4238C9.3373 11.5062 9.89232 11.8772 10.2624 11.7948C10.6324 11.7124 10.6735 11.2383 10.6735 11.2383L11.1669 8.00213C11.2409 7.44032 11.3258 6.90032 11.3936 6.46902C11.4576 6.06165 11.5064 5.75128 11.5164 5.6111Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegramIcon.168bed0261357e420217d8d32fbbf5f3.svg";
export { ForwardRef as ReactComponent };